import React from 'react';
import { Award, Target, Heart } from 'lucide-react';
import { about, teamMembers } from '../data/mock';

const About = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="section-padding" style={{
        background: 'linear-gradient(to bottom, var(--bg-primary) 0%, var(--bg-secondary) 100%)',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1 className="hero-large" style={{ marginBottom: '24px' }}>
            Conheça a OdontoDentine
          </h1>
          <p className="body-large" style={{ maxWidth: '700px', margin: '0 auto', color: 'var(--text-secondary)' }}>
            Nossa história é construída com dedicação, excelência e compromisso com a saúde e o bem-estar dos nossos pacientes.
          </p>
        </div>
      </section>

      {/* Mission, Vision, Values */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '48px'
          }}>
            <div style={{
              border: '1px solid var(--border-light)',
              borderRadius: '0px',
              padding: '40px',
              background: 'var(--bg-secondary)'
            }}>
              <div style={{
                width: '56px',
                height: '56px',
                marginBottom: '24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid var(--border-medium)',
                borderRadius: '0px'
              }}>
                <Target size={28} style={{ color: 'var(--text-primary)' }} />
              </div>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>Missão</h2>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                {about.mission}
              </p>
            </div>

            <div style={{
              border: '1px solid var(--border-light)',
              borderRadius: '0px',
              padding: '40px',
              background: 'var(--bg-secondary)'
            }}>
              <div style={{
                width: '56px',
                height: '56px',
                marginBottom: '24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid var(--border-medium)',
                borderRadius: '0px'
              }}>
                <Award size={28} style={{ color: 'var(--text-primary)' }} />
              </div>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>Visão</h2>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                {about.vision}
              </p>
            </div>

            <div style={{
              border: '1px solid var(--border-light)',
              borderRadius: '0px',
              padding: '40px',
              background: 'var(--bg-secondary)'
            }}>
              <div style={{
                width: '56px',
                height: '56px',
                marginBottom: '24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid var(--border-medium)',
                borderRadius: '0px'
              }}>
                <Heart size={28} style={{ color: 'var(--text-primary)' }} />
              </div>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>Valores</h2>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {about.values.map((value, index) => (
                  <li key={index} className="body-regular" style={{ marginBottom: '8px', color: 'var(--text-secondary)' }}>
                    • {value}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <h2 className="hero-medium" style={{ textAlign: 'center', marginBottom: '60px' }}>Nossa Equipe</h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '32px'
          }}>
            {teamMembers.map((member) => (
              <div key={member.id} style={{
                background: 'var(--bg-primary)',
                border: '1px solid var(--border-light)',
                borderRadius: '0px',
                overflow: 'hidden',
                textAlign: 'center'
              }}>
                <div style={{
                  width: '100%',
                  height: '280px',
                  background: 'var(--bg-secondary)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid var(--border-light)'
                }}>
                  <div style={{
                    width: '120px',
                    height: '120px',
                    borderRadius: '50%',
                    background: 'var(--bg-primary)',
                    border: '2px solid var(--border-medium)'
                  }} />
                </div>
                <div style={{ padding: '24px' }}>
                  <h3 className="heading-2" style={{ marginBottom: '8px' }}>{member.name}</h3>
                  <p className="body-small" style={{ marginBottom: '4px', color: 'var(--text-meta)' }}>
                    {member.specialty}
                  </p>
                  <p className="body-small" style={{ marginBottom: '12px', color: 'var(--text-light)' }}>
                    {member.cro}
                  </p>
                  <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    {member.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Detail Section */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div className="grid-two-column">
            <div>
              <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
                Excelência em Odontologia
              </h2>
              <p className="body-large" style={{ marginBottom: '20px', color: 'var(--text-secondary)' }}>
                Na OdontoDentine, acreditamos que cada sorriso é único e merece um cuidado personalizado. Nossa equipe multidisciplinar trabalha de forma integrada para oferecer soluções completas em odontologia.
              </p>
              <p className="body-large" style={{ marginBottom: '20px', color: 'var(--text-secondary)' }}>
                Investimos constantemente em tecnologia, capacitação profissional e infraestrutura para garantir que nossos pacientes recebam o melhor tratamento disponível.
              </p>
              <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
                Além da competência técnica, valorizamos o atendimento humanizado, criando um ambiente acolhedor onde cada paciente se sente seguro e bem cuidado.
              </p>
            </div>
            <div style={{
              background: 'var(--bg-secondary)',
              borderRadius: '0px',
              height: '400px',
              border: '1px solid var(--border-light)'
            }} />
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;